import { jsx as r } from "react/jsx-runtime";
import { Stack as i } from "./styles89.mjs";
const e = ({
  children: o,
  ...t
}) => /* @__PURE__ */ r(i, { ...t, children: o });
export {
  e as SideNavSection
};
//# sourceMappingURL=index127.mjs.map
